import client from './client';

export const listTickets = (params) => client.get('/api/admin/tickets', { params });
export const getTicket = (id) => client.get(`/api/admin/tickets/${id}`);
export const postTicketMessage = (ticketId, payload) => client.post(`/api/admin/tickets/${ticketId}/messages`, payload);
export const updateTicket = (ticketId, payload) => client.patch(`/api/admin/tickets/${ticketId}`, payload);
export const getTicketsOverview = () => client.get('/api/admin/tickets/overview');
export const assignTicketDepartment = (ticketId, payload) => client.post(`/api/admin/tickets/${ticketId}/assign-department`, payload);
export const assignTicketHandler = (ticketId, payload) => client.patch(`/api/admin/tickets/${ticketId}`, payload);
export const listDepartmentAccounts = (params) => client.get('/api/admin/department-accounts', { params });
export const getDepartmentAccountsSettings = () => client.get('/api/admin/settings/department-accounts');
export const createDepartmentAccount = (payload) => client.post('/api/admin/settings/department-accounts', payload);
export const updateDepartmentAccount = (id, payload) => client.put(`/api/admin/settings/department-accounts/${id}`, payload);
export const deleteDepartmentAccount = (id) => client.delete(`/api/admin/settings/department-accounts/${id}`);
export const resetDepartmentAccountMfa = (id, payload = {}) => {
  const { sudoToken, ...body } = payload ?? {};
  const config = sudoToken
    ? { headers: { 'X-Sudo-Token': sudoToken } }
    : undefined;
  return client.post(`/api/admin/settings/department-accounts/${id}/reset-mfa`, body, config);
};

export const listBenefitPrograms = () => client.get('/api/admin/benefits/programs');
export const listBenefitRequests = (params) => client.get('/api/admin/benefits/requests', { params });
export const getBenefitRequest = (id) => client.get(`/api/admin/benefits/requests/${id}`);
export const getBenefitMetrics = () => client.get('/api/admin/benefits/metrics');

export const listEvents = (params) => client.get('/api/admin/events', { params });
export const getEvent = (id) => client.get(`/api/admin/events/${id}`);
export const createEvent = (payload) => client.post('/api/admin/events', payload);
export const updateEvent = (id, payload) => client.put(`/api/admin/events/${id}`, payload);
export const deleteEvent = (id) => client.delete(`/api/admin/events/${id}`);

export const listVenues = (params) => client.get('/api/admin/venues', { params });
export const getVenue = (id) => client.get(`/api/admin/venues/${id}`);
export const createVenue = (payload) => client.post('/api/admin/venues', payload);
export const updateVenue = (id, payload) => client.put(`/api/admin/venues/${id}`, payload);
export const deleteVenue = (id) => client.delete(`/api/admin/venues/${id}`);
export const toggleVenueVisibility = (id, payload) => client.patch(`/api/admin/venues/${id}/visibility`, payload);
export const deleteVenueImage = (venueId, imageId) => client.delete(`/api/admin/venues/${venueId}/images/${imageId}`);

export const listVenueBookings = (params) => client.get('/api/admin/venue-bookings', { params });
export const getVenueBooking = (id) => client.get(`/api/admin/venue-bookings/${id}`);
export const approveVenueBooking = (id, payload) => client.post(`/api/admin/venue-bookings/${id}/approve`, payload);
export const rejectVenueBooking = (id, payload) => client.post(`/api/admin/venue-bookings/${id}/reject`, payload);
export const getVenueBookingAnalytics = () => client.get('/api/admin/venue-bookings/analytics');
export const getVenueBookingWaybill = (id) => client.get(`/api/admin/venue-bookings/${id}/waybill`, { responseType: 'text' });

export const getReportsSummary = (params) => {
  if (params && typeof params === 'object' && !Array.isArray(params) && Object.prototype.hasOwnProperty.call(params, 'params')) {
    return client.get('/api/admin/reports/summary', params);
  }
  const config = params && typeof params === 'object' ? { params } : undefined;
  return client.get('/api/admin/reports/summary', config);
};
export const getReportFilterOptions = (reportType) => client.get(`/api/admin/reports/filter-options/${reportType}`);
export const exportTicketsReport = (params) => client.get('/api/admin/reports/tickets', { params });
export const exportMembershipReport = (params) => client.get('/api/admin/reports/membership-export', {
  params,
  responseType: 'blob',
  headers: { Accept: 'text/csv' },
});
export const getReportExportHistory = () => client.get('/api/admin/reports/export-history');
export const deleteReportExportHistory = (historyId) => client.delete(`/api/admin/reports/export-history/${historyId}`);
export const downloadReportExportHistory = (historyId) => client.get(`/api/admin/reports/download/${historyId}`, {
  responseType: 'blob',
});
export const exportBuilderReport = (params = {}) => {
  const requestedFormat = typeof params.format === 'string'
    ? params.format.trim().toLowerCase()
    : '';
  const acceptHeader = (() => {
    if (requestedFormat === 'pdf') {
      return 'application/pdf';
    }
    if (requestedFormat === 'excel') {
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    return 'text/csv';
  })();

  return client.post('/api/admin/reports/builder-export', params, {
    responseType: 'blob',
    headers: { Accept: acceptHeader },
  });
};
export const listReportSchedules = (params) => client.get('/api/admin/reports/schedules', { params });
export const updateReportSchedule = (scheduleId, payload) => client.patch(`/api/admin/reports/schedules/${scheduleId}`, payload);
export const createReportSchedule = (payload) => client.post('/api/admin/reports/schedules', payload);
export const deleteReportSchedule = (scheduleId) => client.delete(`/api/admin/reports/schedules/${scheduleId}`);
export const deleteAllReportExportHistory = () => client.delete('/api/admin/reports/export-history');

export const getDashboard = () => client.get('/api/admin/dashboard');
export const getDashboardCharts = () => client.get('/api/admin/dashboard/charts');

export const getCustomOrganizations = () => client.get('/api/admin/settings/organizations/custom');
export const saveCustomOrganizations = (payload) => client.put('/api/admin/settings/organizations/custom', payload);

export const getDataLifecycleOverview = () => client.get('/api/admin/data-lifecycle/overview');
export const archiveLifecycleTable = (payload) => client.post('/api/admin/data-lifecycle/archive', payload);

// Union Management
export const getUnionAffiliations = () => client.get('/api/admin/settings/union-management/affiliations');
export const addUnionAffiliation = (payload) => client.post('/api/admin/settings/union-management/affiliations', payload);
export const updateAffiliationStatus = (id, status) => client.patch(`/api/admin/settings/union-management/affiliations/${id}/status`, { status });
export const updateAffiliationColorTheme = (id, colorTheme) => client.patch(`/api/admin/settings/union-management/affiliations/${id}/color-theme`, { colorTheme });
export const uploadAffiliationLogo = (id, formData) => client.post(`/api/admin/settings/union-management/affiliations/${id}/logo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getUnionCompanies = (affiliationId) => client.get('/api/admin/settings/union-management/companies', affiliationId ? { params: { affiliationId } } : undefined);
export const addUnionCompany = (payload) => client.post('/api/admin/settings/union-management/companies', payload);
export const updateCompanyStatus = (id, status) => client.patch(`/api/admin/settings/union-management/companies/${id}/status`, { status });
export const getUnionNames = (companyId) => client.get('/api/admin/settings/union-management/union-names', companyId ? { params: { companyId } } : undefined);
export const addUnionName = (payload) => client.post('/api/admin/settings/union-management/union-names', payload);
export const updateUnionNameStatus = (id, status) => client.patch(`/api/admin/settings/union-management/union-names/${id}/status`, { status });
export const getUnionPositions = () => client.get('/api/admin/settings/union-management/positions');
export const addUnionPosition = (payload) => client.post('/api/admin/settings/union-management/positions', payload);
export const updatePositionStatus = (id, status) => client.patch(`/api/admin/settings/union-management/positions/${id}/status`, { status });

const adminApi = {
  listTickets,
  getTicket,
  postTicketMessage,
  updateTicket,
  getTicketsOverview,
  assignTicketDepartment,
  assignTicketHandler,
  listDepartmentAccounts,
  getDepartmentAccountsSettings,
  createDepartmentAccount,
  updateDepartmentAccount,
  deleteDepartmentAccount,
  resetDepartmentAccountMfa,
  listBenefitPrograms,
  listBenefitRequests,
  getBenefitRequest,
  getBenefitMetrics,
  listEvents,
  getEvent,
  createEvent,
  updateEvent,
  deleteEvent,
  getReportsSummary,
  getReportFilterOptions,
  exportTicketsReport,
  exportMembershipReport,
  getReportExportHistory,
  deleteReportExportHistory,
  downloadReportExportHistory,
  deleteAllReportExportHistory,
  exportBuilderReport,
  listReportSchedules,
  updateReportSchedule,
  createReportSchedule,
  deleteReportSchedule,
  getDashboard,
  getDataLifecycleOverview,
  archiveLifecycleTable,
  getUnionAffiliations,
  getUnionCompanies,
  getUnionNames,
  getUnionPositions,
};

export default adminApi;
